// extracted by mini-css-extract-plugin
export var container = "OurProducts-module--container--bfad2";
export var left = "OurProducts-module--left--ac6fc";
export var right = "OurProducts-module--right--e8276";